import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosPriorityChangeRequest } from '../models/models'
import { CommonPostResponse } from '../../../components/models/models'

export class ChangeVodafoneEnablePOSApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/changeVodafoneEnablePOS',
      requesterInfo,
    })
  }

  public async changeVodafoneEnablePOS(request: IPosPriorityChangeRequest): Promise<any> {
    return await this.postAsync<IPosPriorityChangeRequest>(request)
  }
}